import fetch from "../components/optionsFetch";
import React, { useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import { Form, Field, FormElement, FieldWrapper } from "@progress/kendo-react-form";
import { FormInput, FormSwitch, FormTextArea, FormDatePicker, FormNumericTextBox, FormDropDownList } from "../components/formComponents";
import { Button } from "@progress/kendo-react-buttons";
import { getMultiSelectTreeValue } from "@progress/kendo-react-dropdowns";
import { processMultiSelectTreeData, expandedState  } from "../components/multiselecttree-data-operations";
import { MultiSelectTreeEditor } from "../components/MultiSelectTreeEditor";
import { GetPermissions } from '../components/Options';
import { formatDate } from '@progress/kendo-intl';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Label } from '@progress/kendo-react-labels';
import { TextBox } from '@progress/kendo-react-inputs';
import ExpansionPanel from "../components/ExpansionPanel";
import { filterBy } from "@progress/kendo-data-query";

const DeleteCell = (props) => {
    const { dataItem } = props;
    return (
        <td>
            <Button icon="delete" onClick={() => props.remove(dataItem)} title="Delete" />
        </td>
    )
}

const FormGrid = fieldArrayRenderProps => {
    const UpdateGrid = fieldArrayRenderProps.update;
    const [edit, setEdit] = React.useState({});

    const CommandCell = (props) => {
        return (
            <DeleteCell {...props} remove={Remove} />
        )
    }

    const handleEditChange = event => {
        setEdit(event.edit);
    }

    const itemChange = (event) => {
        UpdateTC(event.dataItem, event.field, event.value);
    };

    const UpdateTC = (item, field, value) => {
        var url = `${configData.SERVER_URL}apiv7/truckconfigs/${item.Id}`;
        const init = {
            method: 'PUT',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                "truckConfigId": item.Id,
                "truckId": item.TruckId,
                "vehicleConfigurationId": item.VCId,
                "tare": field === "Tare" ? value : item.Tare,
                "maxLoad": field === "MaxLoad" ? value : item.MaxLoad
            })
        }
        fetch(url, init).then(response => response).then(d => {
            UpdateGrid();
        });
    }

    const Remove = (item) => {
        var url = `${configData.SERVER_URL}apiv7/truckConfigs/${item.Id}`;
        const init = {
            method: 'DELETE',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache"
        }
        fetch(url, init).then(response => response).then(d => {
            UpdateGrid();
        });
    }

    return <Grid style={{ height: '420px' }} data={fieldArrayRenderProps.truckConfigs} dataItemKey={"Id"} edit={edit} editable={{ mode: 'incell' }} onEditChange={handleEditChange} onItemChange={itemChange}>
                <Column field="Name" title="Configuration" editable={false} />
                <Column field="Tare" title="Tare (t)" format="{0:n2}" editor="numeric" filter="numeric" />
                <Column field="MaxLoad" title="Maximum Load (t)" format="{0:n2}" editor="numeric" filter="numeric" />
                <Column field="Action" title="Delete" cells={{ data: CommandCell }} editable={false} />
            </Grid>;
};

const EditTrucks = () => {
    const { id } = useParams(); // edittrucks/id url is used to edit existing truck, otherwise id is undefined
    const saveName = id === undefined ? "Create" : "Update";
    const [formkey, setFormkey] = React.useState(0); // seems to be needed to push values to form after loading
    const [directions, setDirections] = React.useState([]);
    const [chargeRates, setChargeRates] = React.useState([]);
    const [loadTypes, setLoadTypes] = React.useState([]);
    const [marks, setMarks] = React.useState([]);
    const [vehicles, setVehicles] = React.useState([]);
    const [drivers, setDrivers] = React.useState([]);
    const [options, setOptions] = React.useState([]);
    const [truckConfigs, setTruckConfigs] = React.useState([]);
    const [selectedTC, setSelectedTC] = React.useState();
    const [tc, setTc] = React.useState([]);
    const [tcTare, setTcTare] = React.useState(0);
    const [tcMaxLoad, setTcMaxLoad] = React.useState(0);
    const [currentProducts, setCurrentProducts] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);    
    const naData = { id: "1", name: "NA" };
    const [submitDisabled, setSubmitDisabled] = React.useState(false);
    const [expandedPanels, setExpandedPanels] = useState({
        truckDetails: true,
        tareDetails: false,
        otherDetails: false,
        linkedData: true,
        truckConfigs: false
    });
    const [driverdata, setdriverData] = React.useState();

    const togglePanel = (panel) => {
        setExpandedPanels(prev => ({ ...prev, [panel]: !prev[panel] }));
    };
    
    const navigate = useNavigate();
    if (localStorage.getItem("userid") === null) navigate("/logout");

    // default layout data for page
    const [layout, setLayout] = React.useState([
        { "field": "truckId","label": "Id","defaultValue": "","isVisible": false,"type": "numeric" },
        { "field": "name","label": "Registration 1","defaultValue": "","isVisible": true,"type": "text" },
        { "field": "code","label": "Code","defaultValue": "","isVisible": true,"type": "text" },
        { "field": "registration2","label": "Registration 2","defaultValue": "","isVisible": true,"type": "text" },
        { "field": "registration3","label": "Registration 3","defaultValue": "","isVisible": true,"type": "text" },
        { "field": "active", "label": "Active", "defaultValue": "true", "isVisible": true, "type": "boolean"},
        { "field": "isTrailer","label": "Trailer Rego","defaultValue": "false","isVisible": true,"type": "boolean" },
        { "field": "fleet","label": "Fleet","defaultValue": "","isVisible": true,"type": "text" },
        { "field": "tagId","label": "Tag Id","defaultValue": "","isVisible": true,"type": "text" },
        { "field": "inOrOut","label": "Goods Direction","defaultValue": "","isVisible": true,"type": "list" },
        { "field": "chargeRate","label": "Charge Rate","defaultValue": "LOCAL","isVisible": true,"type": "list" },
        { "field": "splitTare","label": "Split Tare","defaultValue": "false","isVisible": true,"type": "boolean" },
        { "field": "chargeSiteOwned","label": "Charge Site Owned","defaultValue": "false","isVisible": true,"type": "boolean" },
        { "field": "siteOwned","label": "Site Owned","defaultValue": "false","isVisible": true,"type": "boolean" },
        { "field": "loadType","label": "Load Type","defaultValue": "First","isVisible": true,"type": "list" },
        { "field": "tareTerm","label": "Tare Term (Days)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "lastTareDate","label": "Last Tare Date","defaultValue": new Date(), "isVisible": true, "type": "date" },
        { "field": "tareDetails","label": "Tare and Max GVM details","defaultValue": "","isVisible": true, "type": "heading" },
        { "field": "tare1","label": "Tare 1 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "tare2","label": "Tare 2 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "tare3","label": "Tare 3 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "tare4","label": "Tare 4 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "tare5","label": "Tare 5 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "maxLoad1","label": "Max GVM 1 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "maxLoad2","label": "Max GVM 2 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "maxLoad3","label": "Max GVM 3 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "maxLoad4","label": "Max GVM 4 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "maxLoad5","label": "Max GVM 5 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "maxLoad","label": "Total Max GVM (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "truckDetails","label": "Truck","defaultValue": "","isVisible": true,"type": "heading" },
        { "field": "otherDetails","label": "Other Details","defaultValue": "","isVisible": true,"type": "heading" },
        { "field": "siteDetails","label": "Site Details","defaultValue": "","isVisible": true,"type": "heading" },
        { "field": "linkedData","label": "Relationships","defaultValue": "","isVisible": true,"type": "heading" },
        { "field": "truckConfigs", "label": "Truck Configurations", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "jobId","label": "Job","defaultValue": [],"isVisible": true,"type": "list" },
        { "field": "customerId","label": "Customer","defaultValue": "","isVisible": true,"type": "list" },
        { "field": "productId","label": "Product","defaultValue": "","isVisible": true,"type": "list" },
        { "field": "supplierId","label": "Supplier","defaultValue": "","isVisible": true,"type": "list" },
        { "field": "destinationId","label": "Destination","defaultValue": "","isVisible": true,"type": "list" },
        { "field": "sourceId","label": "Source","defaultValue": "","isVisible": true,"type": "list" },
        { "field": "truckSites","label": "Sites","defaultValue": "","isVisible": true,"type": "list" },
        { "field": "vehicleConfigurationId","label": "Truck Configuration","defaultValue": "","isVisible": true,"type": "list" },
        { "field": "vehicleId","label": "Vehicle Type","defaultValue": {id: 1, name: "NA"},"isVisible": true,"type": "list" },
        { "field": "driverId","label": "Driver","defaultValue": {id: 1, name: "NA"},"isVisible": true,"type": "list" },
        { "field": "markId","label": "Mark","defaultValue": {id: 1, name: "NA"},"isVisible": true,"type": "list" },
        { "field": "description","label": "Comment","defaultValue": "","isVisible": true,"type": "text" },
        { "field": "aBN","label": "ABN","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "maxLoadWarnings","label": "Max Load Warnings","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "lastVisit","label": "Last Visit Date","defaultValue": new Date(),"isVisible": true,"type": "date" },
        { "field": "lastTare1","label": "Last Visit Tare 1 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "lastTare2","label": "Last Visit Tare 2 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "lastTare3","label": "Last Visit Tare 3 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "lastTare4","label": "Last Visit Tare 4 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "lastTare5","label": "Last Visit Tare 5 (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "lastTotalTare","label": "Last Visit Total Tare (t)","defaultValue": 0,"isVisible": true,"type": "numeric" },
        { "field": "tcTare", "label": "Tare (t)", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "tcMaxLoad", "label": "Max Load (t)", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "tcAdd", "label": "Add Configuration", "defaultValue": 0, "isVisible": true, "type": "button" },
        { "field": "permitMaxload", "label": "Permit Max GVM (t)", "defaultValue": 0, "isVisible": false, "type": "numeric" },
        { "field": "permitExpiry", "label": "Permit Expiry", "defaultValue": "", "isVisible": false, "type": "date" },
    ]);
    if (localStorage.getItem("userid") === null) navigate("/logout");

    // Gets field from layout based on field name
    const GetField = (f) => {
        return layout.find(obj => { return obj.field === f });
    }

    // State data for form. Values match form value on submit
    const [values, setValues] = React.useState({
        truckId: GetField("truckId")["defaultValue"],
        name: GetField("name")["defaultValue"],
        code: GetField("code")["defaultValue"],
        registration2: GetField("registration2")["defaultValue"],
        registration3: GetField("registration3")["defaultValue"],
        isTrailer: String(GetField("isTrailer")["defaultValue"]).toLowerCase() === "true",
        fleet: GetField("fleet")["defaultValue"],
        tagId: GetField("tagId")["defaultValue"],
        inOrOut: GetField("inOrOut")["defaultValue"],
        chargeRate: GetField("chargeRate")["defaultValue"],
        splitTare: String(GetField("splitTare")["defaultValue"]).toLowerCase() === "true",
        chargeSiteOwned: String(GetField("chargeSiteOwned")["defaultValue"]).toLowerCase() === "true",
        siteOwned: String(GetField("siteOwned")["defaultValue"]).toLowerCase() === "true",
        loadType: GetField("loadType")["defaultValue"],
        tareTerm: GetField("tareTerm")["defaultValue"],
        lastTareDate: new Date().toString(),
        tareDetails: GetField("tareDetails")["defaultValue"],
        tare1: GetField("tare1")["defaultValue"],
        tare2: GetField("tare2")["defaultValue"],
        tare3: GetField("tare3")["defaultValue"],
        tare4: GetField("tare4")["defaultValue"],
        tare5: GetField("tare5")["defaultValue"],
        maxLoad1: GetField("maxLoad1")["defaultValue"],
        maxLoad2: GetField("maxLoad2")["defaultValue"],
        maxLoad3: GetField("maxLoad3")["defaultValue"],
        maxLoad4: GetField("maxLoad4")["defaultValue"],
        maxLoad5: GetField("maxLoad5")["defaultValue"],
        maxLoad: GetField("maxLoad")["defaultValue"],
        otherDetails: GetField("otherDetails")["defaultValue"],
        jobId: [],
        customerId: [],
        productId: [],
        supplierId: [],
        destinationId: [],
        sourceId: [],
        siteId: [],
        vehicleConfigurationId: [],
        vehicleId: GetField("vehicleId")["defaultValue"],
        driverId: GetField("driverId")["defaultValue"],
        markId: GetField("markId")["defaultValue"],
        description: GetField("description")["defaultValue"],
        aBN: GetField("aBN")["defaultValue"],
        maxLoadWarnings: GetField("maxLoadWarnings")["defaultValue"],
        lastVisit: GetField("lastVisit")["defaultValue"],
        lastTare1: GetField("lastTare1")["defaultValue"],
        lastTare2: GetField("lastTare2")["defaultValue"],
        lastTare3: GetField("lastTare3")["defaultValue"],
        lastTare4: GetField("lastTare4")["defaultValue"],
        lastTare5: GetField("lastTare5")["defaultValue"],
        lastTotalTare: GetField("lastTotalTare")["defaultValue"],
        active: String(GetField("active")["defaultValue"]).toLowerCase() === "true",
        permitMaxload: 0,
        permitExpiry: new Date(),
      });

    React.useEffect(() => {
        GetPermissions(["ViewTruck", "NewTruck", "EditTruck"], setPermissions);
        var url = configData.SERVER_URL + "apiv7/userinterfaces?$filter=viewName eq 'EditTrucks'";
        const init = {
          method: 'GET',
          accept: 'application/json',
          headers: {"Authorization": "Bearer " + GetToken()}
        }
        var lo = null;
        fetch(url, init).then(response => response.json()).then(d => { 
            if (GetSession().IsMobile){
                let data = [];
                for(let i = 0; i < d.length; i++){
                    data.push({field: d[i].field, label: d[i].label, type:d[i].type, format: d[i].format, isVisible: d[i].isVisible && d[i].isVisibleOnMobile});
                }
                setLayout(data);
                lo = data;
            } else {
                setLayout(d); 
                lo = d;
            }
        });
        url = configData.SERVER_URL + "apiv7/options";
        fetch(url, init).then(response => response.json()).then(opt => {           
            setOptions(opt);
            let allSites = GetList(opt.sites);
            let defSites = ConfigureSites(opt.sites, opt.inactiveSites, allSites);
            setMarks(opt.marks);
            setDirections(opt.directions);
            setChargeRates(opt.chargeRates);
            setVehicles(opt.vehicles);
            setDrivers(opt.drivers);
            setdriverData(opt.drivers);
            setTruckConfigs(opt.vehicleConfigurations);
            let lt = []; // filter first in transaction
            for(let i = 0; i < opt.loadTypes.length; i++){
                if (opt.loadTypes[i] !== "Loader") lt.push(opt.loadTypes[i]);
            }
            setLoadTypes(lt);
            let defJobs = ConfigureJobs(opt.jobs, opt.inactiveJobs, "1");
            let defProd = ConfigureProducts(opt.products, opt.inactiveProducts, "1");
            let defSupp = ConfigureSuppliers(opt.suppliers, opt.inactiveSuppliers, "1");
            let defCust = ConfigureCustomers(opt.customers, opt.inactiveCustomers, "1");
            let defSrc = ConfigureSources(opt.sources, opt.inactiveSources, "1");
            let defDest = ConfigureDestinations(opt.destinations, opt.inactiveDestinations, "1");
            if (id !== undefined){
                url = `${configData.SERVER_URL}apiv7/trucks/${id}`;
                fetch(url, init).then(response => response.json()).then(d => {
                    var mk = opt.marks.find(obj => { return obj.id === String(d.markId) });
                    var driver = opt.drivers.find(obj => { return obj.id === String(d.driverId) });
                    var vehicle = opt.vehicles.find(obj => { return obj.id === String(d.vehicleId) });
                    if (vehicle === undefined) vehicle = naData;
                    var ltd = d.lastTareDate === null ? new Date("2000-01-01") : new Date(d.lastTareDate + "Z");
                    var fmt = lo.find(obj => { return obj.field === "lastTareDate" })["format"];
                    var lastTareDate = formatDate(ltd, fmt);
                    var lvd = d.lastVisit === null ? null : new Date(d.lastVisit + "Z");
                    let prod = ConfigureProducts(opt.products, opt.inactiveProducts, d.productList);
                    let supp = ConfigureSuppliers(opt.suppliers, opt.inactiveSuppliers, d.supplierList);
                    let jobs = ConfigureJobs(opt.jobs, opt.inactiveJobs, d.jobList);
                    let cust = ConfigureCustomers(opt.customers, opt.inactiveCustomers, d.customerList);
                    let src = ConfigureSources(opt.sources, opt.inactiveSources, d.sourceList);
                    let dest = ConfigureDestinations(opt.destinations, opt.inactiveDestinations, d.destinationList);
                    let sites = ConfigureSites(opt.sites, opt.inactiveSites, d.siteList);
                    var pex = "";
                    if (d.permitExpiry !== null) pex = new Date(d.permitExpiry + "Z");
                    setValues({
                        truckId: d.truckId === null ? "" : d.truckId,
                        name: d.name === null ? "" : d.name,
                        code: d.code === null ? "" : d.code,
                        registration2: d.registration2 === null ? "" : d.registration2,
                        registration3: d.registration3 === null ? "" : d.registration3,
                        isActive: d.isActive === null ? true : d.isActive,
                        isTrailer: d.isTrailer === null ? false : d.isTrailer,
                        fleet: d.fleet === null ? "" : d.fleet,
                        tagId: d.tagId === null ? "" : d.tagId,
                        inOrOut: d.inOrOut === null ? "" : d.inOrOut,
                        chargeRate: d.chargeRate === null ? "" : d.chargeRate,
                        splitTare: d.splitTare === null ? "" : d.splitTare,
                        chargeSiteOwned: d.chargeSiteOwned === null ? "" : d.chargeSiteOwned,
                        siteOwned: d.siteOwned === null ? false : d.siteOwned,
                        loadType: d.loadType === null ? "" : d.loadType,
                        tareTerm: d.tareTerm === null ? "" : d.tareTerm,
                        lastTareDate: lastTareDate,
                        lastVisit: lvd,
                        tareDetails: d.tareDetails === null ? "" : d.tareDetails,
                        tare1: d.tare1 === null ? "" : d.tare1,
                        tare2: d.tare2 === null ? "" : d.tare2,
                        tare3: d.tare3 === null ? "" : d.tare3,
                        tare4: d.tare4 === null ? "" : d.tare4,
                        tare5: d.tare5 === null ? "" : d.tare5,
                        maxLoad1: d.maxLoad1 === null ? "" : d.maxLoad1,
                        maxLoad2: d.maxLoad2 === null ? "" : d.maxLoad2,
                        maxLoad3: d.maxLoad3 === null ? "" : d.maxLoad3,
                        maxLoad4: d.maxLoad4 === null ? "" : d.maxLoad4,
                        maxLoad5: d.maxLoad5 === null ? "" : d.maxLoad5,
                        maxLoad: d.maxLoad === null ? "" : d.maxLoad,
                        otherDetails: d.otherDetails === null ? "" : d.otherDetails,
                        jobId: jobs,
                        customerId: cust,
                        productId: prod,
                        supplierId: supp,
                        destinationId: dest,
                        sourceId: src,
                        truckSites: sites,
                        vehicleConfigurationId: null,
                        vehicleId: d.vehicleId === null ? "" : vehicle,
                        driverId: d.driverId === null ? "" : driver,
                        markId: d.markId === null ? "" : mk,
                        description: d.description === null ? "" : d.description,
                        aBN: d.aBN === null ? 0 : d.abn,
                        maxLoadWarnings: d.maxLoadWarnings === null ? "" : d.maxLoadWarnings,
                        lastTare1: d.lastTare1 === null ? "" : d.lastTare1,
                        lastTare2: d.lastTare2 === null ? "" : d.lastTare2,
                        lastTare3: d.lastTare3 === null ? "" : d.lastTare3,
                        lastTare4: d.lastTare4 === null ? "" : d.lastTare4,
                        lastTare5: d.lastTare5 === null ? "" : d.lastTare5,
                        lastTotalTare: d.lastTotalTare === null ? "" : d.lastTotalTare,
                        active: d.isActive === null ? true : d.isActive,
                        permitMaxload: d.permitMaxload === null ? 0 : d.permitMaxload,
                        permitExpiry: pex,
                    });
                    UpdateTruckConfigs(opt.vehicleConfigurations);
                    setFormkey(formkey + 1);
                })
            } else {
                let v = {...values};
                v.customerId = defCust;
                v.truckSites = defSites;
                v.jobId = defJobs;
                v.productId = defProd;
                v.supplierId = defSupp;
                v.destinationId = defDest;
                v.sourceId = defSrc;
                setValues(v);
                setFormkey(formkey + 1);
            }
        });
    }, []);

    // Returns value to be sent to web api:
    // If field is visible just return f
    // If field is hidden, return defaultValue from layout data
    const GetDefaultData = (f, name) => {
        let fld = GetField(name);
        if (fld === undefined || fld === null) return f;
        if (fld["isVisible"]) return f;
        let res = "";
        switch(fld["type"]){
            case "text": res = fld["defaultValue"]; break;
            case "numeric": res = parseFloat(fld["defaultValue"]); break;
            case "boolean": res = fld["defaultValue"] === "true"; break;
            default: res = fld["defaultValue"]; break;
        }
        return res;
    }

    // navigation
    const GoBack = () => Redirect("");
    const Redirect = (msg = "") => {
        navigate("/trucks", {state: {msg: msg}});
    }
    if (permissions && !permissions.CanView) navigate("/error401");
    if (permissions && !permissions.CanEdit && id !== undefined) navigate("/error401");
    if (permissions && !permissions.CanCreate && id === undefined) navigate("/error401");

    const dataItemKey = "id";
    const checkField = "checkField";
    const checkIndeterminateField = "checkIndeterminateField";
    const subItemsField = "items";
    const expandField = "expanded";
    const textField = "text";
    const fields = { dataItemKey, checkField, checkIndeterminateField, expandField, subItemsField };

    const GetConfigData = (act, dis, idList) => {
        let slsp = idList == null || idList === "" ? [] : idList.split(',');
        let sl = [];
        let selected = [];
        let inactive = null;
        for (let i = 0; i < act.length; i++){
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            let found = slsp.find(obj => { return obj === String(act[i].id) });
            if (found !== undefined) selected.push(entry);
        }
        let active = {id: 0, text: 'Active', items: sl };
        if (dis !== undefined && dis.length > 0){
            sl = [];
            for (let i = 0; i < dis.length; i++){
                let entry = { text: dis[i].name, id: dis[i].id };
                sl.push(entry);       
                let found = slsp.find(obj => { return obj === String(dis[i].id) });
                if (found !== undefined) selected.push(entry);
            }
            inactive = {id: 999999, text: 'Inactive', items: sl };
        }
        return { active: active, inactive: inactive, selected: selected};
    }

    // state data for JOB multi-select tree   
    const [jobsData, setJobsData] = React.useState([{id:0, text: "Active", items: []}]);
    const [jobsValue, setJobsValue] = React.useState([]);
    const [jobExpanded, setJobExpanded] = React.useState([]);
    const onJobsChange = (event) => {
        setJobsValue(getMultiSelectTreeValue(jobsData, {...fields, ...event, value: jobsValue, }));
    }
    const onJobsExpandChange = React.useCallback((event) => setJobExpanded(expandedState(event.item, dataItemKey, jobExpanded)), [jobExpanded]);
    const jobsTreeData = React.useMemo(() => processMultiSelectTreeData(jobsData, { expanded: jobExpanded, value: jobsValue, ...fields }), [jobExpanded, jobsValue]);
    const ConfigureJobs = (act, dis, idList) => {
        let x = GetConfigData(act, dis, idList);
        if (x.inactive === null)
            setJobsData([x.active]);
        else
        setJobsData([x.active, x.inactive]);
        setJobsValue([...x.selected]);
        return [...x.selected];
    }
    
    // state data for CUSTOMER multi-select tree   
    const [customersData, setCustomersData] = React.useState([{id:0, text: "Active", items: []}]);
    const [customersValue, setCustomersValue] = React.useState([]);
    const [customerExpanded, setCustomerExpanded] = React.useState([]);
    const onCustomersChange = (event) => {
        setCustomersValue(getMultiSelectTreeValue(customersData, {...fields, ...event, value: customersValue, }));
    }
    const onCustomersExpandChange = React.useCallback((event) => setCustomerExpanded(expandedState(event.item, dataItemKey, customerExpanded)), [customerExpanded]);
    const customersTreeData = React.useMemo(() => processMultiSelectTreeData(customersData, { expanded: customerExpanded, value: customersValue, ...fields }), [customerExpanded, customersValue]);
    const ConfigureCustomers = (act, dis, idList) => {
        let x = GetConfigData(act, dis, idList);
        if (x.inactive === null)
            setCustomersData([x.active]);
        else
        setCustomersData([x.active, x.inactive]);
        setCustomersValue([...x.selected]);
        return [...x.selected];
    }

    // state data for PRODUCT multi-select tree   
    const [productsData, setProductsData] = React.useState([{id:0, text: "Active", items: []}]);
    const [productsValue, setProductsValue] = React.useState([]);
    const [productExpanded, setProductExpanded] = React.useState([]);
    const onProductsChange = (event) => {
        setProductsValue(getMultiSelectTreeValue(productsData, {...fields, ...event, value: productsValue, }));
    }
    const onProductsExpandChange = React.useCallback((event) => setProductExpanded(expandedState(event.item, dataItemKey, productExpanded)), [productExpanded]);
    const productsTreeData = React.useMemo(() => processMultiSelectTreeData(productsData, { expanded: productExpanded, value: productsValue, ...fields }), [productExpanded, productsValue]);
    const ConfigureProducts = (act, dis, productList) => {
        let x = GetConfigData(act, dis, productList);
        if (x.inactive === null)
            setProductsData([x.active]);
        else
            setProductsData([x.active, x.inactive]);
        setProductsValue([...x.selected]);
        return [...x.selected];
    }

    // state data for SUPPLIER multi-select tree   
    const [suppliersData, setSuppliersData] = React.useState([{id:0, text: "Active", items: []}]);
    const [suppliersValue, setSuppliersValue] = React.useState([]);
    const [supplierExpanded, setSupplierExpanded] = React.useState([]);
    const onSuppliersChange = (event) => {
        setSuppliersValue(getMultiSelectTreeValue(suppliersData, {...fields, ...event, value: suppliersValue, }));
    }
    const onSuppliersExpandChange = React.useCallback((event) => setSupplierExpanded(expandedState(event.item, dataItemKey, supplierExpanded)), [supplierExpanded]);
    const suppliersTreeData = React.useMemo(() => processMultiSelectTreeData(suppliersData, { expanded: supplierExpanded, value: suppliersValue, ...fields }), [supplierExpanded, suppliersValue]);
    const ConfigureSuppliers = (act, dis, supplierList) => {
        let x = GetConfigData(act, dis, supplierList);
        if (x.inactive === null)
            setSuppliersData([x.active]);
        else
            setSuppliersData([x.active, x.inactive]);
        setSuppliersValue([...x.selected]);
        return [...x.selected];
    }
    
    // state data for SOURCE multi-select tree   
    const [sourcesData, setSourcesData] = React.useState([{id:0, text: "Active", items: []}]);
    const [sourcesValue, setSourcesValue] = React.useState([]);
    const [sourceExpanded, setSourceExpanded] = React.useState([]);
    const onSourcesChange = (event) => {
        setSourcesValue(getMultiSelectTreeValue(sourcesData, {...fields, ...event, value: sourcesValue, }));
    }
    const onSourcesExpandChange = React.useCallback((event) => setSourceExpanded(expandedState(event.item, dataItemKey, sourceExpanded)), [sourceExpanded]);
    const sourcesTreeData = React.useMemo(() => processMultiSelectTreeData(sourcesData, { expanded: sourceExpanded, value: sourcesValue, ...fields }), [sourceExpanded, sourcesValue]);
    const ConfigureSources = (act, dis, sourceList) => {
        let x = GetConfigData(act, dis, sourceList);
        if (x.inactive === null)
            setSourcesData([x.active]);
        else
            setSourcesData([x.active, x.inactive]);
        setSourcesValue([...x.selected]);
        return [...x.selected];
    }

    // state data for DESTINATION multi-select tree 
    const [destData, setDestData] = React.useState([{id:0, text: "Active", items: []}]);
    const [destValue, setDestValue] = React.useState([]);
    const [destExpanded, setDestExpanded] = React.useState([]);
    const onDestChange = (event) => setDestValue(
        getMultiSelectTreeValue(destData, {...fields, ...event, value: destValue, })
    );
    const onDestExpandChange = React.useCallback((event) => setDestExpanded(expandedState(event.item, dataItemKey, destExpanded)), [destExpanded]);
    const destTreeData = React.useMemo(() => processMultiSelectTreeData(destData, { expanded: destExpanded, value:destValue, ...fields }), [destExpanded, destValue]);
    const ConfigureDestinations = (act, dis, destList) => {
        let x = GetConfigData(act, dis, destList);
        if (x.inactive === null)
            setDestData([x.active]);
        else
            setDestData([x.active, x.inactive]);
        setDestValue([...x.selected]);
        return [...x.selected];
        }

    const [sitesData, setSitesData] = React.useState([{id:0, text: "Active", items: []}]);
    const [sitesValue, setSitesValue] = React.useState([]);
    const [siteExpanded, setSiteExpanded] = React.useState([]);
    const onSitesChange = (event) => {
        setSitesValue(getMultiSelectTreeValue(sitesData, {...fields, ...event, value: sitesValue, }));
    }
    const onSitesExpandChange = React.useCallback((event) => setSiteExpanded(expandedState(event.item, dataItemKey, siteExpanded)), [siteExpanded]);
    const sitesTreeData = React.useMemo(() => processMultiSelectTreeData(sitesData, { expanded: siteExpanded, value: sitesValue, ...fields }), [siteExpanded, sitesValue]);
    const ConfigureSites = (act, dis, siteList) => {
        if (siteList === null || siteList === undefined) return [];
        let slsp = siteList.split(',');
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++){
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            let found = slsp.find(obj => { return obj === String(act[i].id) });
            if (found !== undefined) selected.push(entry);
        }
        let active = {id: 0, text: 'Active', items: sl };
        if (dis !== undefined && dis.length > 0){
            sl = [];
            for (let i = 0; i < dis.length; i++){
                let entry = { text: dis[i].name, id: dis[i].id };
                sl.push(entry);       
                let found = slsp.find(obj => { return obj === String(dis[i].id) });
                if (found !== undefined) selected.push(entry);
            }
            let inactive = {id: 999999, text: 'Inactive', items: sl };
            setSitesData([active, inactive]);
        }
        else {
            setSitesData([active]);
        }
        setSitesValue([...selected]);       
        return [...selected];
    }

    const GetList = (obj) => {
        if (obj === undefined || obj === null) return "";
        var l = "";
        for (let i = 0; i < obj.length; i++){
            let id = obj[i].id;
            if (id !== 0 && id !== 999990){
                l += id;
                if (i < obj.length - 1) l += ",";
            }
        }
        return l;
    }

    const Validate = (dataItem) => {
        let st = "";
        if (dataItem.name === undefined || dataItem.name === '') {
            st += "Name\r\n";
        } else {
            let t = options.trucks.find(obj => obj.name === dataItem.name && obj.id !== id);
            if (t !== undefined) st += dataItem.name + " registration already exists.\r\n";
        }
        if (dataItem.code === undefined || dataItem.code === '') st += "Code\r\n";
        if (dataItem.chargeRate === undefined || dataItem.chargeRate === '') st += "Charge Rate\r\n";
        if (dataItem.loadType === undefined || dataItem.loadType === '') st += "Load Type\r\n";
        if (st !== "") {
            setExpandedPanels({ truckDetails: true, tareDetails: false, otherDetails: false, linkedData: false, truckConfigs: false });
            alert("Please enter the following: \r\n" + st);
            return false;
        }
        if (dataItem.vehicleId === undefined || dataItem.vehicleId === '') st += "Vehicle Type\r\n";
        if (dataItem.driverId === undefined || dataItem.driverId === '') st += "Driver\r\n";
        if (dataItem.markId === undefined || dataItem.markId === '') st += "Mark\r\n";
        if (st !== ""){
            setExpandedPanels({ truckDetails: false, tareDetails: false, otherDetails: true, linkedData: false, truckConfigs: false });
            alert("Please enter the following: \r\n" + st);
            return false;
        }
        if (dataItem.loadType === "StoredTare" && dataItem.tare1 + dataItem.tare2 + dataItem.tare3 + dataItem.tare4 + dataItem.tare4 + dataItem.tare5 === 0) {
            setExpandedPanels({ truckDetails: false, tareDetails: true, otherDetails: false, linkedData: false, truckConfigs: false });
            alert("Please enter tare values");
            return false;
        }
        return true;
    }

    // Handle submit button. For create POST the data, for edit PUT the data, then redirect to offenses index page.
    const handleSubmit = () => {
        let dataItem = { ...values };
        if (!Validate(dataItem)) return;   
        var pth = id === undefined ? "" : "/" + id;
        var jobList = GetList(dataItem.jobId);
        var siteList = GetList(dataItem.truckSites);
        var destList = GetList(dataItem.destinationId);
        var srcList = GetList(dataItem.sourceId);
        var custList = GetList(dataItem.customerId);
        var prodList = GetList(dataItem.productId);
        var suppList = GetList(dataItem.supplierId);
        var vcList = GetList(dataItem.vehicleConfigurationId);
        var isFirst = dataItem.loadType === "First";
        var pex = (dataItem.permitExpiry === undefined || dataItem.permitExpiry === "") ? "" : dataItem.permitExpiry.toISOString();
        setSubmitDisabled(true);
        var url = `${configData.SERVER_URL}apiv7/trucks${pth}`;
        const init = {
            method: id === undefined ? 'POST' : 'PUT',
            accept: "application/json",
            headers: {
            "Content-type": "application/json",
            "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
            "truckId": id === undefined ? 0 : id,
            "name": GetDefaultData(dataItem.name, "name"),
            "code": GetDefaultData(dataItem.code, "code"),
            "registration2": GetDefaultData(dataItem.registration2, "registration2"),
            "registration3": GetDefaultData(dataItem.registration3, "registration3"),
            "isTrailer": GetDefaultData(dataItem.isTrailer, "isTrailer"),
            "fleet": GetDefaultData(dataItem.fleet, "fleet"),
            "tagId": GetDefaultData(dataItem.tagId, "tagId"),
            "inOrOut": GetDefaultData(dataItem.inOrOut, "inOrOut"),
            "chargeRate": GetDefaultData(dataItem.chargeRate, "chargeRate"),
            "splitTare": GetDefaultData(dataItem.splitTare, "splitTare"),
            "chargeSiteOwned": GetDefaultData(dataItem.chargeSiteOwned, "chargeSiteOwned"),
            "siteOwned": GetDefaultData(dataItem.siteOwned, "siteOwned"),
            "loadType": GetDefaultData(dataItem.loadType, "loadType"),
            "lastTareDate": dataItem.tareTerm > 0 ? new Date().toISOString() : null, // don't override this, it is set by client
            "tareTerm": GetDefaultData(dataItem.tareTerm, "tareTerm"),
            "lastVisit": GetDefaultData(dataItem.lastVisit, "lastVisit"),
            "tare1": isFirst ? 0 : GetDefaultData(dataItem.tare1, "tare1"),
            "tare2": isFirst ? 0 : GetDefaultData(dataItem.tare2, "tare2"),
            "tare3": isFirst ? 0 : GetDefaultData(dataItem.tare3, "tare3"),
            "tare4": isFirst ? 0 : GetDefaultData(dataItem.tare4, "tare4"),
            "tare5": isFirst ? 0 : GetDefaultData(dataItem.tare5, "tare5"),
            "maxLoad1": GetDefaultData(dataItem.maxLoad1, "maxLoad1"),
            "maxLoad2": GetDefaultData(dataItem.maxLoad2, "maxLoad2"),
            "maxLoad3": GetDefaultData(dataItem.maxLoad3, "maxLoad3"),
            "maxLoad4": GetDefaultData(dataItem.maxLoad4, "maxLoad4"),
            "maxLoad5": GetDefaultData(dataItem.maxLoad5, "maxLoad5"),
            "maxLoad": GetDefaultData(dataItem.maxLoad, "maxLoad"),
            "customerList": custList,
            "productList": prodList,
            "supplierList": suppList,
            "destinationList": destList,
            "sourceList": srcList,
            "siteList": siteList,
            "jobList": jobList,
            "truckConfigurationList": vcList,
            "driverId": GetDefaultData(dataItem.driverId.id, "driverId"),
            "markId": GetDefaultData(dataItem.markId.id, "markId"),
            "vehicleId": GetDefaultData(dataItem.vehicleId.id, "markId"),
            "description": GetDefaultData(dataItem.description, "description"),
            "aBN": GetDefaultData(dataItem.aBN, "aBN"),
            "maxLoadWarnings": GetDefaultData(dataItem.maxLoadWarnings, "maxLoadWarnings"),
            "lastTare1": GetDefaultData(dataItem.lastTare1, "lastTare1"),
            "lastTare2": GetDefaultData(dataItem.lastTare2, "lastTare2"),
            "lastTare3": GetDefaultData(dataItem.lastTare3, "lastTare3"),
            "lastTare4": GetDefaultData(dataItem.lastTare4, "lastTare4"),
            "lastTare5": GetDefaultData(dataItem.lastTare5, "lastTare5"),
            "lastTotalTare": GetDefaultData(dataItem.lastTotalTare, "lastTotalTare"),
            "isActive": GetDefaultData(dataItem.isActive, "active"),
            "permitMaxload": GetDefaultData(dataItem.permitMaxload, "maxLoad"),
            "permitExpiry": pex
            })
        }
        fetch(url, init).then(response => {
            if (response.status > 299 || id === undefined) return response.json();
            return response.text();
        }).then(d => {
            if (d.status !== undefined) {
                if (d.status === 409) {
                    alert("Error: A truck with that registration already exists");
                } else {
                    alert("Error: " + d.detail);
                }
            } else {
                if (id === undefined && d.truckId !== undefined) {
                    navigate(`/edittrucks/${d.truckId}`, { state: { msg: "Truck created" } });
                } else {
                    var msg = id === undefined ? "New truck created" : "Truck updated";
                    Redirect(msg);
                }
            }
        });
    }   
    
    const LoadTypeChanged = (ev) => {
        let type = ev.value;
        let v = { ...values };
        v.loadType = ev.value;
        setValues(v); 
        if (type === "Counted"){
            ConfigureProducts(options.countedProducts, undefined, currentProducts);
        }
        else {
            ConfigureProducts(options.products, options.inactiveProducts, currentProducts);
        }
    }

    function UpdateConfigs() {
        UpdateTruckConfigs(options.vehicleConfigurations);
    }

    const UpdateTruckConfigs = (configs) => {
        let url = configData.SERVER_URL + "apiv7/truckconfigs?$filter=truckId eq " + id;
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        fetch(url, init).then(response => response.json()).then(tc => {
            ConfigureTruckConfigs(tc, configs);
        });
    }

    const ConfigureTruckConfigs = (tc, configs) => {
        let cl = [];
        if (tc !== null) {
            for (let i = 0; i < configs.length; i++) {
                let t = tc.find(obj => { return String(obj.vehicleConfigurationId) === configs[i].id });
                if (t !== undefined) {
                    cl.push({ Id: t.truckConfigId, Name: configs[i].name, Tare: t.tare, MaxLoad: t.maxLoad, TruckId: t.truckId, VCId: t.vehicleConfigurationId });
                }
            }
        }
        setTc(cl);
    }

    const tcUpdated = (newData) => {
        setTc(newData);
    };

    const addTCChanged = (e) => { setSelectedTC(e.value) };

    const addTruckConfigClicked = (e) => {
        e.preventDefault();
        if (selectedTC === undefined || selectedTC === "") {
            alert("Select a truck configuration");
            return;
        }
        var url = `${configData.SERVER_URL}apiv7/truckconfigs`;
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                "truckId": id,
                "vehicleConfigurationId": selectedTC.id,
                "tare": tcTare,
                "maxLoad": tcMaxLoad
            })
        }
        fetch(url, init).then(response => response).then(d => {
            UpdateConfigs();
        });
    }

    const NameChanged = (e) => { let v = { ...values }; v.name = e.value; setValues(v); };
    const CodeChanged = (e) => { let v = { ...values }; v.code = e.value; setValues(v); };
    const Rego2Changed = (e) => { let v = { ...values }; v.registration2 = e.value; setValues(v); };
    const Rego3Changed = (e) => { let v = { ...values }; v.registration3 = e.value; setValues(v); };
    const ActiveChanged = (e) => { let v = { ...values }; v.isActive = e.value; setValues(v); };
    const TrailerChanged = (e) => { let v = { ...values }; v.isTrailer = e.value; setValues(v); };
    const FleetChanged = (e) => { let v = { ...values }; v.fleet = e.value; setValues(v); };
    const TagidChanged = (e) => { let v = { ...values }; v.tagId = e.value; setValues(v); };
    const InOrOutChanged = (e) => { let v = { ...values }; v.inOrOut = e.value; setValues(v); };
    const ChargeRateChanged = (e) => { let v = { ...values }; v.chargeRate = e.value; setValues(v); };
    const SplitTareChanged = (e) => { let v = { ...values }; v.splitTare = e.value; setValues(v); };
    const ChargeSiteOwnedChanged = (e) => { let v = { ...values }; v.chargeSiteOwned = e.value; setValues(v); };
    const SiteOwnedChanged = (e) => { let v = { ...values }; v.siteOwned = e.value; setValues(v); };
    const AbnChanged = (e) => { let v = { ...values }; v.aBN = e.value; setValues(v); };
    const TareTermChanged = (e) => { let v = { ...values }; v.tareTerm = e.value; setValues(v); };
    const LastVisitChanged = (e) => { let v = { ...values }; v.lastVisit = e.value; setValues(v); };
    const Tare1Changed = (e) => { let v = { ...values }; v.tare1 = e.value; setValues(v); };
    const Tare2Changed = (e) => { let v = { ...values }; v.tare2 = e.value; setValues(v); };
    const Tare3Changed = (e) => { let v = { ...values }; v.tare3 = e.value; setValues(v); };
    const Tare4Changed = (e) => { let v = { ...values }; v.tare4 = e.value; setValues(v); };
    const Tare5Changed = (e) => { let v = { ...values }; v.tare5 = e.value; setValues(v); };
    const Maxload1Changed = (e) => { let v = { ...values }; v.maxLoad1 = e.value; setValues(v); };
    const Maxload2Changed = (e) => { let v = { ...values }; v.maxLoad2 = e.value; setValues(v); };
    const Maxload3Changed = (e) => { let v = { ...values }; v.maxLoad3 = e.value; setValues(v); };
    const Maxload4Changed = (e) => { let v = { ...values }; v.maxLoad4 = e.value; setValues(v); };
    const Maxload5Changed = (e) => { let v = { ...values }; v.maxLoad5 = e.value; setValues(v); };
    const VehicleidChanged = (e) => { let v = { ...values }; v.vehicleId = e.value; setValues(v); };
    const DriveridChanged = (e) => { let v = { ...values }; v.driverId = e.value; setValues(v); };
    const MarkidChanged = (e) => { let v = { ...values }; v.markId = e.value; setValues(v); };
    const DescriptionChanged = (e) => { let v = { ...values }; v.description = e.value; setValues(v); };
    const LastTare1Changed = (e) => { let v = { ...values }; v.lastTare1 = e.value; setValues(v); };
    const LastTare2Changed = (e) => { let v = { ...values }; v.lastTare2 = e.value; setValues(v); };
    const LastTare3Changed = (e) => { let v = { ...values }; v.lastTare3 = e.value; setValues(v); };
    const LastTare4Changed = (e) => { let v = { ...values }; v.lastTare4 = e.value; setValues(v); };
    const LastTare5Changed = (e) => { let v = { ...values }; v.lastTare5 = e.value; setValues(v); };
    const LastTotalTareChanged = (e) => { let v = { ...values }; v.lastTotalTare = e.value; setValues(v); };
    const PermitMaxloadChanged = (e) => { let v = { ...values }; v.permitMaxload = e.value; setValues(v); };
    const PermitExpiryChanged = (e) => { let v = { ...values }; v.permitExpiry = e.value; setValues(v); };
    const MaxloadChanged = (e) => { let v = { ...values }; v.maxLoad = e.value; setValues(v); };
    const MaxloadWarningsChanged = (e) => { let v = { ...values }; v.maxLoadWarnings = e.value; setValues(v); };
    const JobidChanged = (e) => { let v = { ...values }; v.jobId = e.value; setValues(v); };
    const CustomerChanged = (e) => { let v = { ...values }; v.customerId = e.value; setValues(v); };
    const ProductChanged = (e) => { let v = { ...values }; v.productId = e.value; setValues(v); };
    const SupplierChanged = (e) => { let v = { ...values }; v.supplierId = e.value; setValues(v); };
    const DestChanged = (e) => { let v = { ...values }; v.destinationId = e.value; setValues(v); };
    const SourceChanged = (e) => { let v = { ...values }; v.sourceId = e.value; setValues(v); };
    const SiteChanged = (e) => { let v = { ...values }; v.siteId = e.value; setValues(v); };

    const filterdriverData = (filter) => {
        const drvdata = drivers.slice();
        return filterBy(drvdata, filter);
    };
    const filterdriverChange = (event) => {
        setdriverData(filterdriverData(event.filter));
    };

    // form validators
    const textValidator = (value) =>  !value ? "Please enter a value" : "";
    const optionValidator = (value) =>  value ? "" : "Please select an option";
      
    return (
        <div style={{ padding: 20, maxWidth: 1200, margin: "auto" }}>
           <Form initialValues={values} key={formkey} render={(formRenderProps) => (
           <FormElement style={{width: "95%"}} >
                    <fieldset className={"k-form-fieldset"}>
                        {GetField("truckDetails")["isVisible"] && <ExpansionPanel title={GetField("truckDetails")["label"]} expanded={expandedPanels.truckDetails} onToggle={() => togglePanel("truckDetails")}>
                        <div className="row">
                            {GetField("name")["isVisible"] && <div className="col-md-3">
                                <Field id={"name"} name={"name"} label={GetField("name")["label"]} component={FormInput} validator={textValidator} onChange={NameChanged} />
                            </div>}
                            {GetField("code")["isVisible"] && <div className='col-md-3'>
                                <Field id={"code"} name={"code"} label={GetField("code")["label"]} component={FormInput} validator={textValidator} onChange={CodeChanged} />
                            </div>}                            
                            {GetField("registration2")["isVisible"] && <div className="col-md-3">
                                <Field id={"registration2"} name={"registration2"} label={GetField("registration2")["label"]} component={FormInput} onChange={Rego2Changed} />
                            </div>}
                            {GetField("registration3")["isVisible"] && <div className="col-md-3">
                                <Field id={"registration3"} name={"registration3"} label={GetField("registration3")["label"]} component={FormInput} onChange={Rego3Changed} />
                            </div>}
                        </div>
                        <div className='row' >
                            {GetField("inOrOut")["isVisible"] && <div className='col-md-3'>
                                <Field id={"inOrOut"} name={"inOrOut"} label={GetField("inOrOut")["label"]} component={FormDropDownList} data={directions} onChange={InOrOutChanged} />
                            </div>}                           
                            {GetField("chargeRate")["isVisible"] && <div className='col-md-3'>
                                <Field id={"chargeRate"} name={"chargeRate"} label={GetField("chargeRate")["label"]} component={FormDropDownList} data={chargeRates} validator={optionValidator} onChange={ChargeRateChanged} />
                            </div>}                           
                            {GetField("loadType")["isVisible"] && <div className='col-md-3'>
                                <Field id={"loadType"} name={"loadType"} onChange={LoadTypeChanged} label={GetField("loadType")["label"]} component={FormDropDownList} data={loadTypes} validator={optionValidator} />
                            </div>}                           
                            {GetField("fleet")["isVisible"] && <div className="col-md-3">
                                <Field id={"fleet"} name={"fleet"} label={GetField("fleet")["label"]} component={FormInput} onChange={FleetChanged} />
                            </div>}
                        </div>                        
                        <div className='row' >
                            {GetField("tagId")["isVisible"] && <div className="col-md-3">
                                <Field id={"tagId"} name={"tagId"} label={GetField("tagId")["label"]} component={FormInput} onChange={TagidChanged} />
                            </div>}
                            {GetField("isTrailer")["isVisible"] && <div className='col-md-3'>
                                <Field id={"isTrailer"} name={"isTrailer"} label={GetField("isTrailer")["label"]} component={FormSwitch} onChange={TrailerChanged} />
                            </div>}                            
                            {GetField("splitTare")["isVisible"] && <div className='col-md-3'>
                                <Field id={"splitTare"} name={"splitTare"} label={GetField("splitTare")["label"]} component={FormSwitch} onChange={SplitTareChanged} />
                            </div>}                            
                            {GetField("chargeSiteOwned")["isVisible"] && <div className='col-md-3'>
                                <Field id={"chargeSiteOwned"} name={"chargeSiteOwned"} label={GetField("chargeSiteOwned")["label"]} component={FormSwitch} onChange={ChargeSiteOwnedChanged} />
                            </div>}                            
                        </div>                        
                        <div className='row' >
                            {GetField("active")["isVisible"] && <div className='col-md-3'>
                                <Field id={"active"} name={"active"} label={GetField("active")["label"]} component={FormSwitch} onChange={ActiveChanged} />
                            </div>}                            
                            {GetField("siteOwned")["isVisible"] && <div className='col-md-3'>
                                <Field id={"siteOwned"} name={"siteOwned"} label={GetField("siteOwned")["label"]} component={FormSwitch} onChange={SiteOwnedChanged} />
                            </div>}                            
                            {GetField("lastTareDate")["isVisible"] && <div className='col-md-3'>
                                <Field id={"lastTareDate"} name={"lastTareDate"} label={GetField("lastTareDate")["label"]} component={FormInput} disabled />
                            </div>}                            
                            {GetField("tareTerm")["isVisible"] && <div className='col-md-3'>
                                <Field id={"tareTerm"} name={"tareTerm"} label={GetField("tareTerm")["label"]} component={FormNumericTextBox} min={0} max={10000} onChange={TareTermChanged} />
                            </div>}
                        </div>         
                        </ExpansionPanel>}
                        {GetField("tareDetails")["isVisible"] && <ExpansionPanel title={GetField("tareDetails")["label"]} expanded={expandedPanels.tareDetails} onToggle={() => togglePanel("tareDetails")}>
                        <div className="row">
                            {GetField("tare1")["isVisible"] && <div className='col-md-3'>
                                <Field id={"tare1"} name={"tare1"} label={GetField("tare1")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={Tare1Changed} />
                            </div>}
                            {GetField("maxLoad1")["isVisible"] && <div className='col-md-3'>
                                <Field id={"maxLoad1"} name={"maxLoad1"} label={GetField("maxLoad1")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={Maxload1Changed} />
                            </div>}
                            {GetField("lastTare1")["isVisible"] && <div className='col-md-3'>
                                <Field id={"lastTare1"} name={"lastTare1"} label={GetField("lastTare1")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={LastTare1Changed} />
                            </div>}
                        </div>
                        <div className="row">
                            {GetField("tare2")["isVisible"] && <div className='col-md-3'>
                                <Field id={"tare2"} name={"tare2"} label={GetField("tare2")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={Tare2Changed} />
                            </div>}
                            {GetField("maxLoad2")["isVisible"] && <div className='col-md-3'>
                                <Field id={"maxLoad2"} name={"maxLoad2"} label={GetField("maxLoad2")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={Maxload2Changed} />
                            </div>}
                            {GetField("lastTare2")["isVisible"] && <div className='col-md-3'>
                                <Field id={"lastTare2"} name={"lastTare2"} label={GetField("lastTare2")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={LastTare2Changed} />
                            </div>}
                        </div>
                        <div className="row">
                            {GetField("tare3")["isVisible"] && <div className='col-md-3'>
                                <Field id={"tare3"} name={"tare3"} label={GetField("tare3")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={Tare3Changed} />
                            </div>}
                            {GetField("maxLoad3")["isVisible"] && <div className='col-md-3'>
                                <Field id={"maxLoad3"} name={"maxLoad3"} label={GetField("maxLoad3")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={Maxload3Changed} />
                            </div>}
                            {GetField("lastTare3")["isVisible"] && <div className='col-md-3'>
                                <Field id={"lastTare3"} name={"lastTare3"} label={GetField("lastTare3")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={LastTare3Changed} />
                            </div>}
                        </div>
                        <div className="row">
                            {GetField("tare4")["isVisible"] && <div className='col-md-3'>
                                <Field id={"tare4"} name={"tare4"} label={GetField("tare4")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={Tare4Changed} />
                            </div>}
                            {GetField("maxLoad4")["isVisible"] && <div className='col-md-3'>
                                <Field id={"maxLoad4"} name={"maxLoad4"} label={GetField("maxLoad4")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={Maxload4Changed} />
                            </div>}
                            {GetField("lastTare4")["isVisible"] && <div className='col-md-3'>
                                <Field id={"lastTare4"} name={"lastTare4"} label={GetField("lastTare4")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={LastTare4Changed} />
                            </div>}
                        </div>
                        <div className="row">
                            {GetField("tare5")["isVisible"] && <div className='col-md-3'>
                                <Field id={"tare5"} name={"tare5"} label={GetField("tare5")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={Tare5Changed} />
                            </div>}
                            {GetField("maxLoad5")["isVisible"] && <div className='col-md-3'>
                                <Field id={"maxLoad5"} name={"maxLoad5"} label={GetField("maxLoad5")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={Maxload5Changed} />
                            </div>}
                            {GetField("lastTare5")["isVisible"] && <div className='col-md-3'>
                                <Field id={"lastTare5"} name={"lastTare5"} label={GetField("lastTare5")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={LastTare5Changed} />
                            </div>}
                        </div>
                        <div className="row">
                            <div className='col-md-3'></div>
                            {GetField("maxLoad")["isVisible"] && <div className='col-md-3'>
                                <Field id={"maxLoad"} name={"maxLoad"} label={GetField("maxLoad")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={MaxloadChanged} />
                            </div>}
                            {GetField("lastTotalTare")["isVisible"] && <div className='col-md-3'>
                                <Field id={"lastTotalTare"} name={"lastTotalTare"} label={GetField("lastTotalTare")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={LastTotalTareChanged} />
                            </div>}
                        </div>
                        {GetField("permitMaxload") && <div className="row">
                            <div className='col-md-3'></div>
                            {GetField("permitMaxload")["isVisible"] && <div className='col-md-3'>
                                <Field id={"permitMaxload"} name={"permitMaxload"} label={GetField("permitMaxload")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={PermitMaxloadChanged} />
                            </div>}
                            {GetField("permitExpiry")["isVisible"] && <div className='col-md-3'>
                                <Field id={"permitExpiry"} name={"permitExpiry"} label={GetField("permitExpiry")["label"]} component={FormDatePicker} onChange={PermitExpiryChanged} />
                            </div>}
                        </div>}
                        </ExpansionPanel>}
                        {GetField("otherDetails")["isVisible"] && <ExpansionPanel title={GetField("otherDetails")["label"]} expanded={expandedPanels.otherDetails} onToggle={() => togglePanel("otherDetails")}>
                        <div className='row' >
                            {GetField("vehicleId")["isVisible"] && <div className='col-md-3'>
                                <Field id={"vehicleId"} name={"vehicleId"} label={GetField("vehicleId")["label"]} component={FormDropDownList} data={vehicles} textField="name" validator={optionValidator} onChange={VehicleidChanged} />
                            </div>}                           
                            {GetField("driverId")["isVisible"] && <div className='col-md-3'>
                                    <Field id={"driverId"} name={"driverId"} label={GetField("driverId")["label"]} component={FormDropDownList} data={driverdata} textField="name" validator={optionValidator} onChange={DriveridChanged} onFilterChange={filterdriverChange} filterable={true} />
                            </div>}                           
                            {GetField("markId")["isVisible"] && <div className='col-md-3'>
                                <Field id={"markId"} name={"markId"} label={GetField("markId")["label"]} component={FormDropDownList} data={marks} textField="name" validator={optionValidator} onChange={MarkidChanged} />
                            </div>}                           
                            {GetField("lastVisit")["isVisible"] && <div className="col-md-3"> 
                                <Field id={"lastVisit"} name={"lastVisit"} label={GetField("lastVisit")["label"]} component={FormDatePicker}
                                            wrapperStyle={{ width: "90%", marginRight: "18px", }} onChange={LastVisitChanged}/>
                            </div>}
                        </div>                        
                        <div className='row' >
                            {GetField("maxLoadWarnings")["isVisible"] && <div className='col-md-3'>
                                <Field id={"maxLoadWarnings"} name={"maxLoadWarnings"} label={GetField("maxLoadWarnings")["label"]} component={FormNumericTextBox} min={0} max={100000} onChange={MaxloadWarningsChanged} />
                            </div>}
                            {GetField("aBN")["isVisible"] && <div className="col-md-3">
                                <Field id={"aBN"} name={"aBN"} label={GetField("aBN")["label"]} component={FormNumericTextBox} onChange={AbnChanged} />
                            </div>}
                            {GetField("description")["isVisible"] && <div className="col-md-3">
                                <Field id={"description"} name={"description"} label={GetField("description")["label"]} component={FormTextArea} onChange={DescriptionChanged} />
                            </div>}
                        </div>               
                        </ExpansionPanel>}
                        {GetField("linkedData")["isVisible"] && <ExpansionPanel title={GetField("linkedData")["label"]} expanded={expandedPanels.linkedData} onToggle={() => togglePanel("linkedData")}>
                        <div className="row">
                                    {GetField("jobId")["isVisible"] && <div className="col-md-6">{GetField("jobId")["label"]}</div>}
                                    {GetField("customerId")["isVisible"] && <div className="col-md-6">{GetField("customerId")["label"]}</div>}
                        </div>                                        
                        <div className='row' >
                            {GetField("jobId")["isVisible"] && <div className='col-md-6'>
                                <Field component={MultiSelectTreeEditor} name={"jobId"} data={jobsTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={JobidChanged} />                                
                            </div>}
                            {GetField("customerId")["isVisible"] && <div className='col-md-6'>
                                <Field component={MultiSelectTreeEditor} name={"customerId"} filterable={true} data={customersTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={CustomerChanged} />                                
                            </div>}
                        </div>
                        <div className="row">
                                    {GetField("productId")["isVisible"] && <div className="col-md-6">{GetField("productId")["label"]}</div>}
                                    {GetField("supplierId")["isVisible"] && <div className="col-md-6">{GetField("supplierId")["label"]}</div>}
                        </div>                                        
                        <div className="row">
                            {GetField("productId")["isVisible"] && <div className='col-md-6'>
                                <Field component={MultiSelectTreeEditor} name={"productId"} data={productsTreeData} value={productsValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={ProductChanged} />                                
                            </div>}
                            {GetField("supplierId")["isVisible"] && <div className='col-md-6'>
                                <Field component={MultiSelectTreeEditor} name={"supplierId"} data={suppliersTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={SupplierChanged} />                                
                            </div>}
                        </div>
                        <div className="row">
                                    {GetField("destinationId")["isVisible"] && <div className="col-md-6">{GetField("destinationId")["label"]}</div>}
                                    {GetField("sourceId")["isVisible"] && <div className="col-md-6">{GetField("sourceId")["label"]}</div>}
                        </div>                                        
                        <div className='row' >
                            {GetField("destinationId")["isVisible"] && <div className='col-md-6'>
                                <Field component={MultiSelectTreeEditor} name={"destinationId"} data={destTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={DestChanged} />                                
                            </div>}
                            {GetField("sourceId")["isVisible"] && <div className='col-md-6'>
                                <Field component={MultiSelectTreeEditor} name={"sourceId"} data={sourcesTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={SourceChanged} />                                
                            </div>}
                        </div>
                        <div className="row">
                            {GetField("siteDetails")["isVisible"] && <div className="col-md-6">{GetField("siteDetails")["label"]}</div>}
                        </div>                                        
                        <div className='row' >
                            {GetField("siteDetails")["isVisible"] && <div className='col-md-6'>
                                <Field component={MultiSelectTreeEditor} name={"truckSites"} data={sitesTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={SiteChanged} />                                
                            </div>}
                        </div>
                        </ExpansionPanel>}
                        {id && GetField("truckConfigs")["isVisible"] && <ExpansionPanel title={GetField("truckConfigs")["label"]} expanded={expandedPanels.truckConfigs} onToggle={() => togglePanel("truckConfigs")}>
                            <div className='row' >
                                {GetField("vehicleConfigurationId")["isVisible"] && <div className='col-md-3'>
                                        <Field id={"vehicleConfigurationId"} name={"vehicleConfigurationId"} label={GetField("vehicleConfigurationId")["label"]} component={FormDropDownList} data={truckConfigs} textField="name" onChange={addTCChanged } />
                                </div>}                           
                                {GetField("tcTare")["isVisible"] && <div className='col-md-3'>
                                    <FieldWrapper>
                                        <Label>{GetField("tcTare")["label"]}</Label>
                                        <Field component={TextBox} id={"tcTare"} name={"tcTare"} type="number" value={tcTare} min={0} max={100000} onChange={(e) => setTcTare(e.value)} />
                                    </FieldWrapper>
                                </div>}
                                    {GetField("tcMaxLoad")["isVisible"] && <div className="col-md-3">
                                    <FieldWrapper>
                                        <Label>{GetField("tcMaxLoad")["label"]}</Label>
                                        <Field component={TextBox} id={"tcMaxLoad"} name={"tcMaxLoad"} type="number" value={tcMaxLoad} min={0} max={100000} onChange={(e)=> setTcMaxLoad(e.value) } />
                                    </FieldWrapper>
                                </div>}
                                    {GetField("tcAdd")["isVisible"] && <div className="col-md-3" style={{paddingTop: "35px"} }>
                                    <Button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={addTruckConfigClicked}>Add</Button>
                                </div>}
                            </div>               
                            <div className='row' >
                                {GetField("productId")["isVisible"] && <div>
                                    <FieldWrapper>
                                        <Field name="productId" dataItemKey={"id"} component={FormGrid} truckConfigs={tc} updated={tcUpdated} truckId={id} update={UpdateConfigs} />
                                    </FieldWrapper>
                                </div>}
                            </div>          
                        </ExpansionPanel>}
                    </fieldset>
                    <div className="k-form-buttons" style={{paddingTop: 10}}>
                        <div className='col-md-1'>
                            <Button themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={handleSubmit} disabled={submitDisabled}>{saveName}</Button>
                        </div>
                        <div className='col-md-1'>
                            <Button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={GoBack}>Cancel</Button>
                        </div>
                    </div>                
                </FormElement>
            )} />
        </div>
    );
}

export default EditTrucks